import { ProfessionIcon } from './profession-icon';

export const IconDeveloper = () => (
  <ProfessionIcon bg="#E8EAF6">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <polyline
        points="16 18 22 12 16 6"
        stroke="#3F51B5"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polyline
        points="8 6 2 12 8 18"
        stroke="#3F51B5"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="14"
        y1="4"
        x2="10"
        y2="20"
        stroke="#3F51B5"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  </ProfessionIcon>
);
